document.addEventListener('DOMContentLoaded', function () {
  document.documentElement.style.setProperty(
    '--announcement-bar-height',
    Math.round(document.getElementById('announcement').clientHeight) + 'px'
  );

  const toggleButton = document.querySelector('.announcement-space--button');
  const announcementSlider = document.querySelector('.announcement-swiper.swiper');

  function updateButtonState(button, isPaused) {
    button.classList.toggle('announcement-space--button-pause', isPaused);
    button.classList.toggle('announcement-space--button-play', !isPaused);
  }

  function toggleSlider(button, slider) {
    const swiper = slider?.swiper;

    if (!swiper || !slider.classList.contains('swiper-initialized')) {
      console.error('Slider is not initialized');
      return;
    }

    const isRunning = swiper.autoplay.running;

    if (isRunning) {
      swiper.params.autoplay.waitForTransition = false;
      swiper.autoplay.pause(0);
      swiper.slideTo(swiper.previousIndex, 0, false);
      swiper.autoplay.stop();
    } else {
      swiper.autoplay.start();
    }

    updateButtonState(button, isRunning);
  }

  if (toggleButton && announcementSlider) {
    toggleButton.addEventListener('click', () => {
      toggleSlider(toggleButton, announcementSlider);
    });
  }
});
